module.exports = __webpack_public_path__ + "img/task.e7419065.svg";